import { BuildType } from './ApiService';

export const featureFlagService = (build: BuildType) => ({
    getFeatureFlags: build.query<{ [key: string]: boolean }, void>({
        query: () => 'feature-flags',
    }),
});
